import { buildCustomerMethods } from './entities/customer'
import { buildDiscountMethods } from './entities/discount'
import { buildInventoryMethods } from './entities/inventory'

export const buildBaseShopifyPlugin = (client, graphQLClient, { vuex }) => {
  const $store = vuex

  const getCheckoutID = () => $store.getters['shopifyOld/getCheckoutID']
  const setLocalCheckout = (newCheckout) =>
    $store.dispatch('shopifyOld/setCheckout', newCheckout)

  return {
    discount: buildDiscountMethods(client, { getCheckoutID, setLocalCheckout }),
    inventory: buildInventoryMethods(graphQLClient),
    customer: buildCustomerMethods(graphQLClient),
  }
}
